/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionParameterValueDto } from './CreateDefinitionParameterValueDto';
import {
    CreateDefinitionParameterValueDtoFromJSON,
    CreateDefinitionParameterValueDtoFromJSONTyped,
    CreateDefinitionParameterValueDtoToJSON,
} from './CreateDefinitionParameterValueDto';

/**
 * 
 * @export
 * @interface CreateDefinitionParameterValueSetDto
 */
export interface CreateDefinitionParameterValueSetDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueSetDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueSetDto
     */
    setIdentifier?: string;
    /**
     * 
     * @type {Array<CreateDefinitionParameterValueDto>}
     * @memberof CreateDefinitionParameterValueSetDto
     */
    values?: Array<CreateDefinitionParameterValueDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueSetDto
     */
    protocolId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueSetDto
     */
    $type?: CreateDefinitionParameterValueSetDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDefinitionParameterValueSetDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionParameterValueSetDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDefinitionParameterValueSetDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDefinitionParameterValueSetDtoTypeEnum = typeof CreateDefinitionParameterValueSetDtoTypeEnum[keyof typeof CreateDefinitionParameterValueSetDtoTypeEnum];



/**
 * Check if a given object implements the CreateDefinitionParameterValueSetDto interface.
 */
export function instanceOfCreateDefinitionParameterValueSetDto(value?: unknown): value is CreateDefinitionParameterValueSetDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDefinitionParameterValueSetDtoTypeEnum)[0];
}

export function CreateDefinitionParameterValueSetDtoFromJSON(json: any): CreateDefinitionParameterValueSetDto {
    return CreateDefinitionParameterValueSetDtoFromJSONTyped(json, false);
}

export function CreateDefinitionParameterValueSetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionParameterValueSetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'setIdentifier': json['setIdentifier'] == null ? undefined : json['setIdentifier'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(CreateDefinitionParameterValueDtoFromJSON)),
        'protocolId': json['protocolId'] == null ? undefined : json['protocolId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateDefinitionParameterValueSetDtoToJSON(value?: CreateDefinitionParameterValueSetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'setIdentifier': value['setIdentifier'],
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(CreateDefinitionParameterValueDtoToJSON)),
        'protocolId': value['protocolId'],
        '$type': value['$type'],
    });
}

